import React from 'react';
import { Icon } from '../../elements/icon';

const QuizEmailSlideContent = ({ t, emailField, slideValues, slideCode, handleValueChange }) => {
  return (
    <div className="t-flex t-flex-col t-mt-4">
      <h2 className="t-font-serif t-text-[28px] sm:t-text-[38px] t-leading-[1.05] t-text-navy t-mb-4 t-m-0">
        {t('Quiz_Email_Title')}
      </h2>
      <p className="t-text-base sm:t-text-lg t-leading-[1.3] t-text-g500 t-m-0 t-mb-7">{t('Quiz_Email_Subtitle')}</p>

      <div className="t-space-y-3 t-mb-6">
        <div className="t-flex t-items-center t-gap-3">
          <div className="t-h-10 t-w-10 t-rounded-full t-bg-[#E6F2EE] t-flex t-items-center t-justify-center t-shrink-0">
            <Icon raw name="quizEmailCheck" size={16} />
          </div>
          <p className="t-textsm lg:t-text-base t-text-navy t-m-0">{t('Quiz_Email_Benefit_1')}</p>
        </div>
        <div className="t-flex t-items-center t-gap-3">
          <div className="t-h-10 t-w-10 t-rounded-full t-bg-[#E6F2EE] t-flex t-items-center t-justify-center t-shrink-0">
            <Icon raw name="quizEmailLock" size={16} />
          </div>
          <p className="t-textsm lg:t-text-base t-text-navy t-m-0">{t('Quiz_Email_Benefit_2')}</p>
        </div>
        <div className="t-flex t-items-center t-gap-3">
          <div className="t-h-10 t-w-10 t-rounded-full t-bg-[#E6F2EE] t-flex t-items-center t-justify-center t-shrink-0">
            <Icon raw name="quizEmailList" size={16} />
          </div>
          <p className="t-textsm lg:t-text-base t-text-navy t-m-0">{t('Quiz_Email_Benefit_3')}</p>
        </div>
      </div>

      {emailField && (
        <input
          type="email"
          id={emailField.name}
          placeholder={t('Quiz_Email_Placeholder')}
          value={slideValues[slideCode]?.[emailField.name]?.value ?? ''}
          onChange={(e) => handleValueChange(emailField, emailField.name, e.target.value)}
          className="t-w-full t-py-3.5 t-px-4 t-border-2 t-border-g200 t-rounded-xl t-font-sans t-text-base t-text-navy t-bg-white t-outline-none focus:t-border-quiz-teal placeholder:t-text-g300 t-mb-3"
        />
      )}

      <p className="t-text-g500 t-text-sm t-leading-relaxed t-text-center t-mt-4 t-mb-0">{t('Quiz_Email_Consent')}</p>
    </div>
  );
};

export default QuizEmailSlideContent;
